import React from 'react';

const Security = () => {
  return (
    <div className="legal-page">
      <section className="hero">
        <div className="container">
          <h1>Security & Trust</h1>
          <p>How we secure data, infrastructure, and software delivery across all projects.</p>
        </div>
      </section>
      <section className="section">
        <div className="container legal-content">
          <h2>Security Principles</h2>
          <ul>
            <li>Least-privilege access controls and role-based permissions.</li>
            <li>Encrypted data in transit and at rest.</li>
            <li>Secure SDLC practices with code review and dependency scanning.</li>
            <li>Routine backups, monitoring, and incident response process.</li>
          </ul>
          <h2>Contact</h2>
          <p>For security inquiries: security@msatechnologies.com</p>
        </div>
      </section>
    </div>
  );
};

export default Security;

